import { render, staticRenderFns } from "./CharactersWeaponFocuses.vue?vue&type=template&id=0bb71a2b&lang=pug&"
import script from "./CharactersWeaponFocuses.vue?vue&type=script&lang=ts&"
export * from "./CharactersWeaponFocuses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports